const GoogleIcon = () => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0)">
                <path
                    d="M15.671 6.545H8.035V9.818H12.363C11.671 12 9.962 12.727 8 12.727C7.2397 12.728 6.49038 12.5455 5.81563 12.1951C5.14087 11.8447 4.56059 11.3368 4.12402 10.7143C3.68744 10.0918 3.40746 9.37322 3.30782 8.61947C3.20819 7.86573 3.29183 7.09907 3.55167 6.38454C3.81151 5.67001 4.23986 5.0287 4.8004 4.51503C5.36093 4.00135 6.0371 3.63046 6.77154 3.43382C7.50597 3.23719 8.27701 3.22061 9.01922 3.3855C9.76143 3.55039 10.4529 3.89188 11.035 4.381L13.413 2.116C12.4554 1.23383 11.2969 0.598747 10.0381 0.265867C8.77933 -0.0670124 7.45833 -0.0876225 6.1898 0.205826C4.92126 0.499275 3.74351 1.09791 2.75881 1.94977C1.77411 2.80163 1.01221 3.88096 0.539251 5.09406C0.0662954 6.30716 -0.10342 7.61737 0.0448392 8.91094C0.193098 10.2045 0.65485 11.4423 1.39001 12.517C2.12517 13.5916 3.11151 14.4706 4.26342 15.0775C5.41532 15.6845 6.69797 16.0012 8 16C12.411 16 16.4 13.091 15.671 6.545Z"
                    fill="#4B10FF"
                />
            </g>
            <defs>
                <clipPath id="clip0">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default GoogleIcon;
